<template>
    <layout-basic>
        <v-container>
            <section class="banner-text">
                <v-row class="text-center">
                    <v-col md="12">
                        <h1 class="font-sora thanks-title">Thank you!</h1>
                        <p class="thanks-subtext fs-22">Thanks for contacting us. One of our team will get in touch with you shortly.</p>
                    </v-col>
                </v-row>
            </section>
        </v-container>
    </layout-basic>
</template>

<script>
    import LayoutBasic from "@/layouts/Dashboard";
    export default {
        name: "Thankyou",
        components: {
            LayoutBasic,
        },
        // A confirmation page: worth a real title for the tab and for screen
        // readers, but never worth a search result, so noindex. It is left out
        // of the sitemap and the prerender set for the same reason (siteRoutes.js).
        metaInfo() {
            return {
                title: "Thank you | Improve Online",
                meta: [
                    { name: "description", content: "Thanks for contacting IMPROVE. One of our team will be in touch shortly." },
                    { name: "robots", content: "noindex, follow" },
                ],
                link: [{ rel: "canonical", href: "https://www.improve.online/thank-you" }],
            };
        },
    }
</script>